import { useThemeContext } from "../../contexts/themecontext";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import { IconButton, useTheme } from "@mui/material";
import "./layout.css";

const ToggleThemeButton = () => {
  const { toggleTheme } = useThemeContext();
  const theme = useTheme();

  return (
    <IconButton
      aria-label={
        theme.palette.mode === "dark"
          ? "Switch to light mode"
          : "Switch to dark mode"
      }
      onClick={toggleTheme}
    >
      {theme.palette.mode === "dark" ? (
        <LightModeIcon fontSize="small" />
      ) : (
        <DarkModeIcon fontSize="small" />
      )}
    </IconButton>
  );
};

export default ToggleThemeButton;
